import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import AppRoutes from './routes';
import { useAuthStore } from './stores/authStore';
import { useSettingsStore } from './stores/settingsStore';
import ErrorBoundary from './components/common/ErrorBoundary';
import { ToastProvider } from './components/common/ToastContainer';

/**
 * Native-auth app shell (VSNP-653).
 *
 * Keycloak is no longer the redirect target — we own login at /login.
 * Session state lives entirely in authStore; fetching platform settings is
 * gated on having a valid VSN+ session. Everything KC-related is back-of-house
 * via the API's Admin client.
 */
function App() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const { fetchGeneral, fetchUserPrefs, fetchFeatureFlags } = useSettingsStore();

  useEffect(() => {
    if (isAuthenticated) {
      fetchGeneral();
      fetchUserPrefs();
      fetchFeatureFlags();
    }
  }, [isAuthenticated, fetchGeneral, fetchUserPrefs, fetchFeatureFlags]);

  return (
    <ErrorBoundary>
      <ToastProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;
